(() => {
  const currentScript = document.currentScript;
  const section = currentScript.closest('section');

  if (!section || section.dataset.tabbedInitialized) return;

  section.dataset.tabbedInitialized = 'true';

  const buttons = section.querySelectorAll('.mr-tab-button');
  const contents = section.querySelectorAll('.mr-tab-content');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.target;
      const targetContent = section.querySelector(`#${targetId}`);

      if (!targetContent) return;

      // Remove 'active' from all buttons and contents in this section
      buttons.forEach(btn => btn.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));

      // Activate the clicked button and its corresponding content
      button.classList.add('active');
      targetContent.classList.add('active');
    });
  });
})();
